export function runOnDocumentLoaded(callback: () => void) {
  if (document.readyState !== 'loading') {
    return callback();
  }

  const listener = () => {
    callback();

    document.removeEventListener('DOMContentLoaded', listener, false);
  };

  document.addEventListener('DOMContentLoaded', listener, false);
}
